/**
 * Created by nobook on 2018/3/6.
 */
import Vue from 'vue';
import NotFound from './pages/common/404';

//班级管理
import ManageClass from './pages/exam/ManageClass.vue'
import ClassMember from './pages/exam/ClassMember.vue'
import MemberDetails from './pages/exam/MemberDetails.vue'
import TestDetails from './pages/exam/TestDetails.vue'
import TestList from './pages/exam/TestList.vue'
import ExperimentalLibrary from './pages/exam/ExperimentalLibrary.vue'
import ExaminationCentre from './pages/exam/ExaminationCentre.vue'
import StoreTestRecord from './pages/exam/StoreTestRecord.vue'
import StoreExamStatistics from './pages/exam/StoreExamStatistics.vue'
import StudentExanCentre from './pages/exam/StudentExanCentre.vue'
import StudentExamDetails from './pages/exam/StudentExamDetails.vue'
import TeacherCenter from './pages/exam/TeacherCenter.vue'

const root = Vue.component('root', {
    template: '<router-view></router-view>'
});

let routes = [


    {
        path: '/404',
        component: NotFound,
        name: '404',
        // meta: {
        //   requiresAuth: true
        // }
    },
    {
        path: '/',
        component: root,
        redirect: '/experimentallibrary',
        // meta: {
        //   requiresAuth: true
        // },
        children: [
            {

                path: 'manageclass',
                name: '班级管理',
                component: ManageClass,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'classmember',
                name: '班级成员',
                component: ClassMember,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'memberdetails',
                name: '成员详情',
                component: MemberDetails,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'testdetails',
                name: '实验详情',
                component: TestDetails,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'testlist',
                name: '实验列表',
                component: TestList,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'experimentallibrary',
                name: '实验库',
                component: ExperimentalLibrary,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'examinationcentre',
                name: '考试中心',
                component: ExaminationCentre,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'storetestrecord',
                name: '实验库',
                component: StoreTestRecord,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'storeexamstatistics',
                name: '自测记录',
                component: StoreExamStatistics,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'studentexancentre',
                name: '考试记录',
                component: StudentExanCentre,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'studentexamdetails',
                name: '考试详情',
                component: StudentExamDetails,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },{

                path: 'teachercenter',
                name: '个人中心',
                component: TeacherCenter,
                imgUrl: 'https://o0p2g4ul8.qnssl.com/vsite%2Fbackground.jpg',
                iconClass: 'el-icon-document'
            },
        ]
    },
    {
        path: '*',
        redirect: { path: '/404' }
    },
];
let menuCount = routes.length;
routes[menuCount - 2].children.forEach(route => {
    if (route.children) {
        if (!route.meta) route.meta = {};
        route.meta.children = route.children;
    }
});

export default routes;



// WEBPACK FOOTER //
// ./src/assets/js/routes_student.js